import type { Formatters, Locale } from 'react-day-picker';

const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const createCalendarFormatters = (
  locale: Locale,
): Partial<Formatters> => ({
  formatCaption: (month: Date) => {
    const formatted = new Intl.DateTimeFormat(locale.code, {
      month: 'long',
      year: 'numeric',
    }).format(month);

    const withoutYearSuffix = formatted.replace(/\s*р\.?$/i, '');

    return capitalize(withoutYearSuffix);
  },
  formatWeekdayName: (weekday: Date) => {
    const formatted = new Intl.DateTimeFormat(locale.code, {
      weekday: 'short',
    }).format(weekday);

    return capitalize(formatted);
  },
});
